// Send via Quo (texts from Kelly's Quo business number). Only these sign-in emails see the button;
// the server also enforces QUO_ALLOWED_EMAILS.
import { auth } from '../firebaseConfig';

export const QUO_UI_EMAILS = ['kelly.olin@exprealty.com'];
export const canUseQuo = () => QUO_UI_EMAILS.includes(String(auth.currentUser?.email || '').toLowerCase());

// Returns { ok, dryRun, error, to, from }.
export const sendViaQuo = async (to, content, link = {}) => { // link: { contactId, transactionId, pipelineId } for the Messages Log
  const idToken = await auth.currentUser.getIdToken();
  const res = await fetch('/api/quo-send-sms', { method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${idToken}` }, body: JSON.stringify({ to, content, ...link }) });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) return { ok: false, error: data.error || `Could not send (error ${res.status}).` };
  return { ok: !data.dryRun, dryRun: !!data.dryRun, to: data.to, from: data.from };
};
